import { render, staticRenderFns } from "./SocietyMatchWizardsStepOne.vue?vue&type=template&id=23f23505&scoped=true"
import script from "./SocietyMatchWizardsStepOne.vue?vue&type=script&lang=js"
export * from "./SocietyMatchWizardsStepOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f23505",
  null
  
)

export default component.exports